module.exports = __webpack_public_path__ + "static/assets/ed2e8ddf3110ae01c46533a8cfebb5d9.png";